import Component from 'flarum/common/Component';
export default class SlideTab extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.tabList = this.attrs.tabList;
    this.showTabLine = this.attrs.showTabLine;
    this.selectedIndex = -1;
    this.style = this.attrs.style;
    this.id = this.attrs.id || "SlideTabID" + Math.round(Math.random() * 10000);
    this.component = this.attrs.component || function () {};
    this.offsetX = this.attrs.offsetX || 0;
    this.touchstartX = 0;
    this.touchendX = 0;
    if (this.showTabLine === undefined) {
      this.showTabLine = true;
    }
  }
  handleGesture() {
    let triggered = false;
    if (this.touchendX < this.touchstartX) {
      if (this.tabList.length > this.selectedIndex) {
        this.selectedIndex++;
        triggered = true;
      }
    }
    if (this.touchendX > this.touchstartX) {
      if (this.selectedIndex > 1) {
        this.selectedIndex--;
        triggered = true;
      }
    }
    if (triggered) {
      $("#katerSlideTab-item-" + this.id + this.selectedIndex).click();
    }
  }
  oncreate() {
    this.checkHashTag();
    const _this = this;

    /*
    const isMobile = window.zivenCore.isMobile();
     if(isMobile){
      const gestureElement = document.getElementById("TabContainer"); // Or any other selector
       gestureElement.addEventListener('touchstart', e => {
          _this.touchstartX = e.changedTouches[0].screenX;
      });
       gestureElement.addEventListener('touchend', e => {
          _this.touchendX = e.changedTouches[0].screenX;
          _this.handleGesture();
          _this.touchstartX = 0;
          _this.touchendX = 0;
      });
    }
    */
  }
  checkHashTag() {
    const dom = $("#" + this.id);
    if (dom.length === 0) {
      return;
    }
    let urlHash = window.location.hash.substring(1);
    let tagChanged = false;
    for (let i = 0; i < this.tabList.length; i++) {
      if (this.tabList[i].key === urlHash) {
        const index = i + 1;
        if (this.selectedIndex != index) {
          this.selectedIndex = index;
          tagChanged = true;
        }
        break;
      }
    }
    if (this.selectedIndex === -1) {
      this.selectedIndex = 1;
      tagChanged = true;
    }
    if (tagChanged) {
      const screenWidth = screen.width;
      const containerWidth = $("#katerSlideTabMenuContainer" + this.id).width();
      $("#katerSlideTabLine" + this.id).width(containerWidth > screenWidth ? containerWidth : "100%");
      $("#katerSlideTab-item-" + this.id + this.selectedIndex).click();
    }
    $("#katerSlideTabBar" + this.id).css('width', $("#katerSlideTabBar" + this.id).css('width', $("#katerSlideTab-item-" + this.id + this.selectedIndex).parent().find("span").outerWidth()));
  }
  selectItem(e, tabKey, tabEvent) {
    var _app$current;
    // 2026-07-31 v0.4.7.1: 1.8 mithril Stream .get() → 2.0 PageState .data.routeName
    const routeName = String(((_app$current = app.current) == null || (_app$current = _app$current.data) == null ? void 0 : _app$current.routeName) || '');
    const target = e.target;
    const elemCount = parseInt($(target).attr("count"));
    let marginLeft = parseInt(this.offsetX);
    for (let i = 1; i < elemCount; i++) {
      marginLeft += $("#katerSlideTab-item-" + this.id + i).parent().find("span").outerWidth();
    }
    $("#" + this.id).animate({
      scrollLeft: marginLeft - window.screen.width / 2 + $(target).parent().width() / 2
    }, 350);
    $("#katerSlideTabBar" + this.id).css('marginLeft', marginLeft);
    $("#katerSlideTabBar" + this.id).css('width', $("#katerSlideTab-item-" + this.id + elemCount).parent().find("span").outerWidth());
    tabEvent(e, tabKey);
    window.location.hash = tabKey;
    history.replaceState(undefined, undefined, "#" + tabKey);
  }
  view() {
    this.checkHashTag();
    return m("div", {
      id: this.id,
      style: this.style,
      className: "katerSlideTabMenu"
    }, this.component(), m("div", {
      id: "katerSlideTabMenuContainer" + this.id,
      style: "margin-left: " + this.offsetX + "px;",
      className: "katerSlideTabMenuContainer"
    }, this.tabList.map((tabData, index) => {
      const tabName = app.translator.trans(tabData.name);
      const tabEvent = tabData.event;
      const tabKey = tabData.key;
      const selectedIndex = index + 1;
      let tabWidth = tabData.width || "";
      let tempTab = document.createElement("DIV");
      tempTab.style.fontSize = "20px";
      tempTab.style.fontWeight = "bold";
      tempTab.style.padding = "10px";
      tempTab.style.width = "fit-content";
      tempTab.innerHTML = tabName;
      document.body.appendChild(tempTab);
      tabWidth = $(tempTab).outerWidth();
      document.body.removeChild(tempTab);
      return m("div", null, m("input", {
        type: "radio",
        count: selectedIndex,
        name: "katerSlideTabItem" + this.id,
        id: "katerSlideTab-item-" + this.id + selectedIndex,
        className: "katerSlideTabToggle",
        onclick: e => {
          this.selectItem(e, tabKey, tabEvent);
          this.selectedIndex = selectedIndex;
        }
      }), m("label", {
        style: "width:" + (tabWidth === "" ? "max-content" : tabWidth + "px"),
        for: "katerSlideTab-item-" + this.id + selectedIndex
      }, m("span", null, tabName)));
    })), m("div", {
      className: "katerSlideTabClear"
    }), m("div", {
      className: "katerSlideTab"
    }, this.showTabLine === true && m("div", {
      id: "katerSlideTabLine" + this.id,
      className: "katerSlideTabLine"
    }), m("div", {
      id: "katerSlideTabBar" + this.id,
      className: "katerSlideTabBar"
    })));
  }
}
flarum.reg.add('ziiven-ziven-core', 'common/components/SlideTab', SlideTab);